// extracted by mini-css-extract-plugin
export default {"legalLinks":"style_legalLinks__yiD1d"};